import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  type ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  memberPickerApiBaseUrlInterceptor,
  provideMemberPickerApiBaseUrl,
} from '@sbe-spinoff-schoolbell-e/member-picker-config';
import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // 유일한 기능(MemberPickerComponent)이 signal 기반 상태만 쓴다 — 리팩터 불필요.
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([memberPickerApiBaseUrlInterceptor])),
    provideMemberPickerApiBaseUrl(environment.apiUrl),
  ],
};
